<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-relative">
      <button
        class="close"
        type="button"
        (click)="onClose()"
        aria-label="Close"
      >
        <span aria-hidden="true"><i class="material-icons">close</i></span>
      </button>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-5">
      <img class="gif gifRedemptionDowntime" src="{{ genericData.img }}" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mb-3 mt-3">
      <p class="message">{{ genericData.title }}</p>
      <div
        *ngIf="genericData.scheduleDowntime"
        class="d-flex align-items-center justify-content-center mt-2"
      >
        <span class="d-flex align-items-center mr-3">
          <mat-icon class="mr-1 icon">calendar_today</mat-icon>
          <span>{{ genericData.startDate }}</span>
        </span>
        <span class="d-flex align-items-center">
          <mat-icon class="mr-1 icon">access_time</mat-icon>
          <span>{{ genericData.startTime }}</span>
        </span>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center align-items-center" *ngIf="!genericData?.confirmButton; else confirm">
      <button
        class="btn blue-btn mb-4"
        (click)="onClose()"
      >
        Close
      </button>
    </div>
    <ng-template #confirm>
      <div class="d-flex justify-content-center align-items-center mb-4">
        <button class="btn blue-btn mr-3" (click)="onConfirm()">Confirm</button>
        <button class="btn" (click)="onClose()">Cancel</button>
      </div>
    </ng-template>
  </div>
</div>
